// extracted by mini-css-extract-plugin
export default {"container":"src-components-LinkModule-Components-Head-style-module__container---2y4B"};